import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";
import {
  auditTime,
  distinct,
  distinctUntilChanged,
  first,
} from "rxjs/operators";
import * as fromApp from "../../../../store/app.reducer";
import * as selectors from "../../../../store/app.selectors";
import { ProductDetailsOperationsService } from "../../../product-details-operations.service";
import { OptionValidationService } from "../../option-validation-service/option-validation.service";

@Component({
  selector: "app-bundle-option-radio",
  templateUrl: "./bundle-option-radio.component.html",
  styleUrls: ["./bundle-option-radio.component.scss"],
})
export class BundleOptionRadioComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() selectedProductId: any;
  @Input() product_id;
  @Input() productName: any;
  @Input() bundleMode: any;
  @Input() option_id;
  @Input() must_select_something: any;
  @Input() selectedProductPromo: any;
  @Input() selectedProductCategory: any;
  @Input() selectedProductFreeParentOption: any;
  @Input() selectedProductParentDiscount;
  @Input() disable_qty: any;
  @Input() rootProductParentBundleChoice;
  @Input() groupStoreData: any;
  @Output() bundleRadioOptionChanged = new EventEmitter();

  public option: any;
  public validationObject: any;
  public selectAllChoices: boolean;
  public orderPickup: boolean;
  public dineIn: boolean;

  private subscriptions: Subscription[] = [];
  private optionSubscription: Subscription;
  private lastValidTimestamp: any;

  constructor(
    private translateService: TranslateService,
    private store: Store<fromApp.AppState>,
    private optionValidationService: OptionValidationService,
    private productDetailsOperationsService: ProductDetailsOperationsService
  ) {}

  selectOption() {
    if (this.optionSubscription) {
      this.optionSubscription.unsubscribe();
    }
    this.optionSubscription = this.store
      .select(
        selectors.getOptionByOptionId(this.selectedProductId, this.option_id)
      )
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (!_.isEqual(this.option, state)) {
          this.option = _.cloneDeep(state);

          console.log(this.option);
        }
      });
  }
  ngOnInit() {
    // console.log("bundle-radio-option on init", this.option_id);

    this.subscriptions.push(
      this.store
        .select("deliveryMethodAddress")
        .pipe(distinctUntilChanged())
        .pipe(auditTime(50))
        .subscribe((state) => {
          if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
            this.orderPickup = _.cloneDeep(state.orderPickup);
          }

          if (state && !_.isEqual(this.dineIn, state.dineIn)) {
            this.dineIn = _.cloneDeep(state.dineIn);
          }
        })
    );
    this.subscriptions.push(
      this.store
        .select("productOptionsValidation")
        .pipe(distinctUntilChanged())
        .subscribe((state: any) => {
          if (
            state.lastValidTimestampBySelectedProductId &&
            state.lastValidTimestampBySelectedProductId[
              this.selectedProductId
            ] &&
            state.optionValidationsBySelectedProductId &&
            !_.isEqual(
              this.lastValidTimestamp,
              state.lastValidTimestampBySelectedProductId[
                this.selectedProductId
              ]
            )
          ) {
            this.lastValidTimestamp = _.cloneDeep(
              state.lastValidTimestampBySelectedProductId[
                this.selectedProductId
              ]
            );
            // console.log("call validate opt...");
            this.validationObject = this.optionValidationService.validateOption(
              this.option,
              null,
              this.lastValidTimestamp,
              this.must_select_something,
              this.orderPickup,
              this.bundleMode,
              this.product_id,
              null,
              this.productName,
              this.selectedProductId,
              this.dineIn
            );
            if (!this.validationObject.valid) {
              //console.log("option is not valid", this.option.option_id);
              const el: any = document.getElementById(
                this.option.option_id.toString()
              );
              if (el) {
                el.style.setProperty("--ion-background-color", "#ffd6d6");
              }
            } else {
              //console.log("option is valid", this.option.option_id);
              const el: any = document.getElementById(
                this.option.option_id.toString()
              );
              if (el) {
                el.style.setProperty(
                  "--ion-background-color",
                  "--ion-background-color"
                );
              }
            }
          }
        })
    );
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (
      simpleChange &&
      simpleChange.option_id &&
      simpleChange.option_id.currentValue !==
        simpleChange.option_id.previousValue
    ) {
      this.selectOption();
    }
  }

  changedOption(newoption) {
    this.option = _.cloneDeep(newoption);
    this.assignFreeChoices();
    this.calculateTotalChoiceQuantity();
    this.store
      .select(selectors.getStoreInfo)
      .pipe()
      .subscribe((store_info) => {
        this.store
          .select("deliveryMethodAddress")
          .pipe(first())
          .subscribe((state) => {
            this.productChoicesPriceComment(
              state.orderPickup,
              state.dineIn,
              store_info && store_info.dinein
                ? store_info.alt_dinein_active
                : false,
              state.selectedDineInTable
            );
          })
          .unsubscribe();
      });

    console.log("call validate opt...");
    this.validationObject = this.optionValidationService.validateOption(
      this.option,
      null,
      this.lastValidTimestamp,
      this.must_select_something,
      this.orderPickup,
      this.bundleMode,
      this.product_id,

      null,
      this.productName,
      this.selectedProductId,
      this.dineIn
    );
    if (!this.validationObject.color) {
      console.log("option is not valid", this.option.option_id);
      const el: any = document.getElementById(this.option.option_id.toString());
      if (el) {
        el.style.setProperty("--ion-background-color", "#ffd6d6");
      }
    } else {
      console.log("option is valid", this.option.option_id);
      const el: any = document.getElementById(this.option.option_id.toString());
      if (el) {
        el.style.setProperty(
          "--ion-background-color",
          "--ion-background-color"
        );
      }
    }
    console.log("checkbox emit", this.option);
    this.bundleRadioOptionChanged.emit(this.option);
  }

  onSelectAll() {
    this.selectAllChoices = !this.selectAllChoices;
    if (this.option && this.option.choices && this.selectAllChoices) {
      _.each(this.option.choices, (ch) => {
        ch.is_preselected = true;
      });
    } else if (this.option && this.option.choices && !this.selectAllChoices) {
      _.each(this.option.choices, (ch) => {
        ch.is_preselected = false;
      });
    }
  }

  calculateTotalChoiceQuantity() {
    if (!this.option.option_id) {
      return;
    }
    console.log("calculatingTotalChoiceQuantity");
    let choicesQuantity = 0;
    if (this.option && this.option.choices && this.option.choices.length) {
      _.each(this.option.choices, (choice) => {
        if (
          choice.is_preselected &&
          choice.activeTotal &&
          choice.availableTotal
        ) {
          choicesQuantity = choicesQuantity + choice.quantity;
        }
      });
      if (!this.option.optionData) {
        this.option.optionData = {};
      }
      this.option.optionData.freeChoices =
        choicesQuantity >= parseInt(this.option.freeChoices)
          ? this.option.freeChoices
          : choicesQuantity;
      this.option.optionData.maxChoices =
        choicesQuantity >= parseInt(this.option.maxChoices)
          ? this.option.maxChoices
          : choicesQuantity;
      this.option.optionData.minChoices =
        choicesQuantity >= parseFloat(this.option.minChoices)
          ? this.option.minChoices
          : choicesQuantity;
    }
  }

  productChoicesPriceComment(
    orderPickup,
    dineIn,
    alt_dinein_active,
    selectedDineInTable
  ) {
    if (this.option) {
      _.each(this.option.choices, (choice, c, q) => {
        if (choice.isFree && choice.quantity === choice.freeQuantity) {
          this.option.choices[c].choicePriceComment = this.option.choices[
            c
          ].choicePriceComment =
            this.productDetailsOperationsService.handle_choice_step_price(
              choice,
              orderPickup,
              dineIn,
              alt_dinein_active,
              selectedDineInTable
            ) +
            ((this.option.alwaysShowChoicesQuantity || choice.quantity !== 1
              ? " x" + choice.quantity + ": "
              : " ") +
              this.translateService.instant("product-details.free"));
        } else {
          let tempPrice;
          if (orderPickup == true && dineIn == false && choice.price_takeaway) {
            tempPrice =
              choice.price_takeaway.toString().trim().replace(",", ".") *
              (choice.quantity - choice.freeQuantity);
            this.option.choices[c].choicePriceComment =
              this.productDetailsOperationsService.handle_choice_step_price(
                choice,
                orderPickup,
                dineIn,
                alt_dinein_active,
                selectedDineInTable
              ) +
              (choice.price_takeaway
                ? (this.option.alwaysShowChoicesQuantity ||
                  choice.quantity !== 1
                    ? " x" + choice.quantity + ": "
                    : " ") +
                  parseFloat(tempPrice.toString()).toFixed(2) +
                  "€"
                : this.option.alwaysShowChoicesQuantity || choice.quantity !== 1
                ? " x" + choice.quantity
                : "");
          } else if (
            orderPickup == false &&
            dineIn == true &&
            (!alt_dinein_active ||
              !selectedDineInTable ||
              !selectedDineInTable.alt_dinein ||
              !choice.price_alt_dinein) &&
            choice.price_dinein
          ) {
            tempPrice =
              choice.price_dinein.toString().trim().replace(",", ".") *
              (choice.quantity - choice.freeQuantity);
            this.option.choices[c].choicePriceComment =
              this.productDetailsOperationsService.handle_choice_step_price(
                choice,
                orderPickup,
                dineIn,
                alt_dinein_active,
                selectedDineInTable
              ) +
              (choice.price_dinein
                ? (this.option.alwaysShowChoicesQuantity ||
                  choice.quantity !== 1
                    ? " x" + choice.quantity + ": "
                    : " ") +
                  parseFloat(tempPrice.toString()).toFixed(2) +
                  "€"
                : this.option.alwaysShowChoicesQuantity || choice.quantity !== 1
                ? " x" + choice.quantity
                : "");
          } else if (
            orderPickup == false &&
            dineIn == true &&
            !alt_dinein_active &&
            !selectedDineInTable &&
            !selectedDineInTable.alt_dinein &&
            !choice.price_alt_dinein &&
            choice.price_alt_dinein
          ) {
            tempPrice =
              choice.price_alt_dinein.toString().trim().replace(",", ".") *
              (choice.quantity - choice.freeQuantity);
            this.option.choices[c].choicePriceComment =
              this.productDetailsOperationsService.handle_choice_step_price(
                choice,
                orderPickup,
                dineIn,
                alt_dinein_active,
                selectedDineInTable
              ) +
              (choice.price_alt_dinein
                ? (this.option.alwaysShowChoicesQuantity ||
                  choice.quantity !== 1
                    ? " x" + choice.quantity + ": "
                    : " ") +
                  parseFloat(tempPrice.toString()).toFixed(2) +
                  "€"
                : this.option.alwaysShowChoicesQuantity || choice.quantity !== 1
                ? " x" + choice.quantity
                : "");
          } else {
            tempPrice =
              choice.price.toString().trim().replace(",", ".") *
              (choice.quantity - choice.freeQuantity);
            this.option.choices[c].choicePriceComment =
              this.productDetailsOperationsService.handle_choice_step_price(
                choice,
                orderPickup,
                dineIn,
                alt_dinein_active,
                selectedDineInTable
              ) +
              (choice.price
                ? (this.option.alwaysShowChoicesQuantity ||
                  choice.quantity !== 1
                    ? " x" + choice.quantity + ": "
                    : " ") +
                  parseFloat(tempPrice.toString()).toFixed(2) +
                  "€"
                : this.option.alwaysShowChoicesQuantity || choice.quantity !== 1
                ? " x" + choice.quantity
                : "");
          }
        }
      });

      if (
        this.option.reverseChoices &&
        !_.isEmpty(this.option.preselectedChoices)
      ) {
        //console.log("kalw tin find choice comment ");

        this.store
          .select("deliveryMethodAddress")
          .pipe(first())
          .subscribe((state) => {
            this.option.choicesComment =
              this.productDetailsOperationsService.findChoicesComment(
                this.option,
                state.orderPickup,
                state.dineIn,
                alt_dinein_active,
                selectedDineInTable
              );
          })
          .unsubscribe();
      }
    }
  }

  assignFreeChoices() {
    if (!this.option.option_id) {
      //There are some options that do not have option_id
      return;
    }

    let optionsFreeChoices = parseInt(this.option.freeChoices);

    let sortByVariable: any = "price";

    if (
      this.option &&
      this.option.freeChoices &&
      this.option.freeChoicesBySelectionOrder
    ) {
      sortByVariable = "selected_timestamp";
    }

    if (
      this.option &&
      this.option.freeChoices &&
      this.option.freeChoicesByPosition
    ) {
      sortByVariable = (choice, index) => index;
    }

    const sortedChoices = _.sortBy(
      this.option.choices,
      (choice: any, index) => {
        if (sortByVariable === "price") {
          if (this.orderPickup && choice.price_takeaway) {
            sortByVariable = "price_takeway";
            return choice.price_takeaway;
          } else if (this.dineIn && choice.price_dinein) {
            sortByVariable = "price_dinein";
            return choice.price_dinein;
          }
          return choice.price;
        } else if (typeof sortByVariable === "function") {
          return sortByVariable(choice, index);
        } else {
          return choice[sortByVariable];
        }
      }
    );

    _.each(sortedChoices, (choice: any, key, list) => {
      if (
        this.dineIn &&
        (!choice.price || choice.price === 0) &&
        (!choice.price_dinein || choice.price_dinein === 0) &&
        this.option.freeChoicesbyPriceSkipZeros
      ) {
        return;
      }
      if (
        this.orderPickup &&
        (!choice.price_takeaway || choice.price_takeaway === 0) &&
        (!choice.price || choice.price === 0) &&
        this.option.freeChoicesbyPriceSkipZeros
      ) {
        return;
      }

      if (
        !this.orderPickup &&
        !this.dineIn &&
        (!choice.price || choice.price === 0) &&
        this.option.freeChoicesbyPriceSkipZeros
      ) {
        return;
      }

      if (
        optionsFreeChoices > 0 &&
        choice.is_preselected &&
        choice.activeTotal &&
        choice.availableTotal
      ) {
        this.option.choices[
          _.findIndex(this.option.choices, {
            choice_id: choice.choice_id,
          })
        ].isFree = true;
        if (choice.quantity > 1) {
          if (optionsFreeChoices - choice.quantity >= 0) {
            this.option.choices[
              _.findIndex(this.option.choices, {
                choice_id: choice.choice_id,
              })
            ].freeQuantity = choice.quantity;
            optionsFreeChoices -= choice.quantity;
          } else {
            this.option.choices[
              _.findIndex(this.option.choices, {
                choice_id: choice.choice_id,
              })
            ].freeQuantity = optionsFreeChoices;
            optionsFreeChoices -= optionsFreeChoices;
          }
        } else {
          this.option.choices[
            _.findIndex(this.option.choices, {
              choice_id: choice.choice_id,
            })
          ].freeQuantity = 1;
          optionsFreeChoices -= 1;
        }
      } else {
        this.option.choices[
          _.findIndex(this.option.choices, {
            choice_id: choice.choice_id,
          })
        ].isFree = false;
        this.option.choices[
          _.findIndex(this.option.choices, {
            choice_id: choice.choice_id,
          })
        ].freeQuantity = 0;
      }
    });
    optionsFreeChoices = null;
  }

  toFloat(num) {
    return parseFloat(num.toString());
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
    if (this.optionSubscription) {
      this.optionSubscription.unsubscribe();
    }
  }
}
